<template>
    <div class="page home">

        <home-skeleton style="margin-top: 20px;margin-bottom: 100vh" v-if="loading"></home-skeleton>

        <div v-show="!loading">
            <div class="home-header">
                <van-search class="header-search" @click="$router.push({name:'search'})" v-model="value" placeholder="搜一搜"/>
            </div>

            <div class="tags" ref="homeTags">
                <van-tabs v-model="category_index" @click="changeCategory">
                    <van-tab v-for="(item,index) in categories" :key="index" :name="index" :title="item.title" ></van-tab>
                </van-tabs>
                <div class="clear"></div>
            </div>

            <div v-if="category_index == 0">
                <div class="swipe" style="margin-left: 15px;">
                    <swiper :options="swiperOptionBanner" v-if="banners.length > 0" indicator-color="#fff" touchable>
                        <swiper-slide v-for="(item,i) in banners"  :key="i">
                            <a :href="item.target_url.replace('https://dr-yyh.com','https://dr-yyh.com')">
                                <img :src="item.img" alt="">
                            </a>
                        </swiper-slide>
                    </swiper>
                </div>

                <div class="home-nav-2">
                    <swiper :options="swiperOption3" indicator-color="#fff" touchable>
                        <swiper-slide v-for="(item,i) in position_type1"  :key="i">
                            <van-image @click="goTopic(item)" :src="item.logo" />
                            <br>
                            {{ item.title }}
                        </swiper-slide>
                    </swiper>

                    <swiper v-if="position_type2 && position_type2.length > 0" style="margin-top: 15px" :options="swiperOption3" indicator-color="#fff" touchable ref="swipe4">
                        <swiper-slide v-for="(item,i) in position_type2" :key="i">
                            <van-image @click="goTopic(item)" :src="item.logo" />
                            <br>
                            {{ item.title }}
                        </swiper-slide>
                    </swiper>
                </div>

                <div v-for="(item,i) in recommend" :key="item.id">
                    <!--竖排课程-->
                    <div class="home-section" v-if="item.layout == 1 && item.module_type == 1">
                        <div class="home-title">{{item.module_name}}</div>
                        <div class="course-list-section">
                            <van-row @click="go_detail(val)" v-for="val in item.module_data" :key="val.id">
                                <div class="course-list-section-box">
                                    <div class="course-list-section-left">
                                        <van-image
                                            fit="cover"
                                            class="course-list-section-left-img"
                                            :src="val.cover_img"
                                            width="100%"
                                            height="81"
                                        />
                                        <img v-if="val.type==2" class="course-list-section-left-zl" src="/static/img/icon_list_tag_column.svg" alt="">
                                    </div>
                                    <div class="course-list-section-right">
                                        <div class="course-list-section-right-title">{{val.title}}</div>
                                        <div class="course-list-section-right-author" v-if="val.type != 2">{{val.doctor}} · {{item.hospital}}</div>
                                        <div class="course-list-section-right-author" v-else>{{val.course_desc}}</div>
                                        <div class="course-list-section-right-detail">{{val.view_count}}人学习</div>
                                    </div>
                                </div>
                            </van-row>
                        </div>
                    </div>

                    <!--竖排直播-->
                    <div class="home-section" v-else-if="item.layout == 1 && item.module_type == 4">
                        <div class="home-title">{{item.module_name}}</div>
                        <div class="live-list-section">
                            <van-row @click="go_live_detail(val)" v-for="val in item.module_data" :key="val.id">
                                <div class="live-list-section-box">
                                    <div class="live-list-section-left">
                                        <img class="live-list-section-left-img" :src="val.cover_img">
                                        <img v-if="val.type === 2" class="live-list-section-left-zl"
                                             src="/static/img/icon_list_tag_column.svg" alt="">
                                        <img v-else-if="val.live_status===0" class="live-list-section-left-zl"
                                             src="/static/img/live/icon_list_tag_live_count_down.svg" alt="">
                                        <img v-else-if="val.live_status===1" class="live-list-section-left-zl"
                                             src="/static/img/live/icon_list_tag_live_process.svg" alt="">
                                        <img v-else-if="val.live_status>2" class="live-list-section-left-zl"
                                             src="/static/img/live/icon_list_tag_live_history.svg" alt="">
                                        <div class="live-list-section-left-time" v-if="val.live_status>1"><span>{{val.duration_format}}</span></div>
                                    </div>
                                    <div class="live-list-section-right">
                                        <div class="live-list-section-right-title" v-html="val.title"></div>
                                        <div class="live-list-section-right-detail">
                                            <span v-if="val.type === 2">{{val.live_desc}}</span>
                                            <span v-else-if="val.live_status < 2">{{val.start_at}}</span>
                                            <span v-else>{{val.view_count}}人观看</span>
                                            <span class="live-list-section-right-detail-join" v-if="val.type != 2 && val.live_status===0">预约</span>
                                            <span class="live-list-section-right-detail-join" v-else-if="val.type != 2 && val.live_status===1">加入</span>
                                        </div>
                                    </div>
                                </div>
                            </van-row>
                        </div>
                    </div>

                    <!-- 横排课程 -->
                    <div class="home-section"  v-else-if="item.layout === 2 && item.module_type === 1"  style="padding-top: 0px;background: #f7f7f8">
                        <div class="live-column-section">
                            <div class="column-section-title">{{item.module_name}}</div>
                            <swiper ref="mySwiper" :options="swiperOption" style="margin-top: 15px">
                                <swiper-slide class="column-section-swiper" v-for="val in item.module_data" :key="val.id">
                                    <van-image
                                        fit="cover"
                                        width="100%"
                                        height="120"
                                        :src="val.cover_img"
                                        @click="go_detail(val)"
                                    />
                                    <div class="column-section-content"  @click="go_detail(val)">
                                        <div class="column-section-content-title">{{val.title}}</div>
                                        <div class="column-section-content-desc" v-if="val.type != 2">{{val.doctor}} · {{val.hospital}}</div>
                                        <div class="column-section-content-desc" v-else>{{val.course_desc}}</div>
                                        <div class="column-section-content-detail" v-if="val.type != 2">{{val.view_count}}人学习</div>
                                        <div class="column-section-content-detail" v-else>已开展{{val.current_count}}期</div>
                                    </div>
                                </swiper-slide>
                            </swiper>
                        </div>
                    </div>

                    <!-- 横排直播 -->
                    <div class="home-section" v-else-if="item.layout == 2 && item.module_type == 4"  style="padding-top: 0px;background: #f7f7f8">
                        <div class="live-column-section">
                            <div class="column-section-title">{{item.module_name}}</div>
                            <div v-swiper:mySwiper="swiperOption" ref="liveSwipe" style="margin-top: 15px">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide column-section-swiper" v-for="val in item.module_data" :key="val.id" @click="go_live_detail(val)">
                                        <van-image
                                            fit="cover"
                                            width="100%"
                                            height="120"
                                            :src="val.cover_img"
                                            class="column-section-swiper-img"
                                        />
                                        <div class="column-section-content">
                                            <div class="column-section-content-title">{{val.title}}</div>
                                            <div class="column-section-content-desc" v-if="val.type != 2">{{val.doctor}} · {{val.hospital}}</div>
                                            <div class="column-section-content-desc" v-else>{{val.live_desc}}</div>
                                            <div class="column-section-content-detail" v-if="val.type != 2">{{val.view_count}}人学习</div>
                                            <div class="column-section-content-detail" v-else>已开展{{val.current_count}}期</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--竖排短视频-->
                    <div class="home-section" v-else-if="item.module_type == 3">
                        <div class="home-title">{{item.module_name}}</div>
                        <van-row class="short-video-list-section">
                            <div class="short-video-list-box" v-for="val in item.module_data" :key="val.id" @click="$router.push({name:'short-video-detail',params:{id:val.id}})">
                                <div class="short-video-list-box-img">
                                    <van-image
                                        fit="cover"
                                        :src="val.cover_img"
                                        width="100%"
                                        height="100%"
                                    />
                                    <div class="short-video-list-box-play-count">
                                        <img src="/static/img/icon_live_watch.svg" alt="">
                                        {{val.view_count}}
                                    </div>
                                </div>
                                <div class="short-video-list-box-title">{{val.title}}</div>
                            </div>
                        </van-row>
                    </div>
                    <div class="clear"></div>
                </div>

                <div class="home-section" style="border: 0;padding-bottom: 60px">
                    <div class="home-title">资讯</div>
                    <div class="article-list-section">
                        <van-row class="article-list-section-box" @click="goArticle(item)" v-for="item in articles" :key="item.id">
                            <van-col span="8">
                                <van-image
                                    fit="cover"
                                    class="article-list-content-img"
                                    :src="item.cover_img"
                                    width="112"
                                    height="72"
                                />
                                <img v-if="item.type === 2" class="article-list-section-box-zl" src="/static/img/icon_list_tag_column.svg" alt="">
                            </van-col>
                            <van-col span="16" class="article-list-content">
                                <div class="article-list-title">{{item.title.length > 34 ? item.title.substr(0,34)+'...' : item.title}}</div>
                                <div class="article-list-content-desc">
                                    {{item.desc.length > 26 ? item.desc.substr(0,26)+'...' : item.desc}}
                                </div>
                                <div class="article-list-content-detail">
                                    <div v-if="item.type == 2">
                                        已更新{{item.current_count}}篇 | 共{{item.total_count}}篇
                                    </div>
                                    <div v-else>
                                        {{item.created_at}}
                                        <span style="margin-left: 8px">{{item.view_count}}人阅读</span>
                                    </div>
                                </div>
                            </van-col>
                        </van-row>
                    </div>
                    <div class="clear"></div>
                    <div class="van-list__finished-text" v-if="page === total_page">没有更多了</div>
                    <div v-else class="finish-more" @click="fetch_more()">查看更多</div>
                </div>
            </div>
            <div v-else>
                <div class="channels">
                    <div class="channel-section" v-for="(item,i) in tableData" :key="i" @click="handleChannelItem(item)">

                        <div v-if="item.origin_type == 1" class="course-list-section">
                            <van-row>
                                <div class="course-list-section-box">
                                    <div class="course-list-section-left" style="height: 72px">
                                        <van-image
                                            fit="cover"
                                            class="course-list-section-left-img"
                                            :src="item.cover_img"
                                            width="100%"
                                            height="72"
                                        />
                                        <img class="course-list-section-left-play" src="/static/two/icon_viedo_play_32.svg" alt="">
                                        <img v-if="item.type==2" class="course-list-section-left-zl" src="/static/two/icon_list_tag_subject_video.svg" alt="">
                                    </div>
                                    <div class="course-list-section-right">
                                        <div class="course-list-section-right-title">{{item.title}}</div>
                                        <div class="course-list-section-right-detail" v-if="item.type==2">已更新{{item.current_count}}节 | 共{{item.course_count}}节</div>
                                        <div class="course-list-section-right-detail" v-else>{{item.created_at}} {{item.view_count}}人学习</div>
                                    </div>
                                    <div class="clear"></div>
                                </div>
                            </van-row>
                            <div class="clear"></div>
                        </div>

                        <div v-else-if="item.origin_type == 2" class="article-list-section" style="padding-top: 0">
                            <van-row class="article-list-section-box">
                                <van-col span="8">
                                    <van-image
                                        fit="cover"
                                        class="article-list-content-img"
                                        :src="item.cover_img"
                                        width="100%"
                                        height="74"
                                    />
                                    <div class="article-list-section-box-zl" v-if="item.type == 2">
                                        <img src="/static/two/icon_list_tag_subject_text.svg" alt="">
                                    </div>
                                </van-col>
                                <van-col span="16" class="article-list-content">
                                    <div class="article-list-title">{{item.title}}</div>
                                    <div class="article-list-content-desc" v-if="item.desc">
                                        {{item.desc}}
                                    </div>
                                    <div class="article-list-content-detail">
                                        <div v-if="item.type == 2">已更新{{item.current_count}}篇 | 共{{item.total_count}}篇</div>
                                        <div v-else>{{item.created_at}}<span style="margin-left: 8px">{{item.view_count}}人阅读</span></div>
                                    </div>
                                </van-col>
                            </van-row>
                            <div class="clear"></div>
                        </div>
                        <div v-else-if="item.origin_type == 3" class="course-list-section" style="padding-top: 0;padding-bottom: 0px">
                            <van-row>
                                <div class="course-list-section-box">
                                    <div class="course-list-section-left" style="height: 72px">
                                        <van-image
                                            fit="cover"
                                            class="course-list-section-left-img"
                                            :src="item.cover_img"
                                            width="100%"
                                            height="72"
                                        />
                                        <img class="course-list-section-left-play" src="/static/two/icon_viedo_play_32.svg" alt="">
                                        <img v-if="item.type==2" class="course-list-section-left-zl" src="/static/two/icon_list_tag_subject_video.svg" alt="">
                                    </div>
                                    <div class="course-list-section-right">
                                        <div class="course-list-section-right-title">{{item.title}}</div>
                                        <div class="course-list-section-right-detail" v-if="item.type==2">已更新{{item.current_count}}节 | 共{{item.total_count}}节</div>
                                        <div class="course-list-section-right-detail" v-else>{{item.created_at}} {{item.view_count}}人学习</div>
                                    </div>
                                    <div class="clear"></div>
                                </div>
                            </van-row>
                            <div class="clear"></div>
                        </div>

                        <div v-else-if="item.origin_type == 4" class="live-list-section" style="padding-top: 0;padding-bottom: 0;">
                            <div class="live-list-section-box">
                                <div class="live-list-section-left">
                                    <van-image
                                        class="live-list-section-left-img"
                                        fit="cover"
                                        :src="item.cover_img"
                                    />
                                    <img v-if="item.type==2" class="course-list-section-left-zl" src="/static/two/icon_list_tag_subject_live.svg" alt="">
                                    <img v-else-if="item.live_status==0" class="live-list-section-left-zl" src="/static/img/live/icon_list_tag_live_count_down.svg" alt="">
                                    <img v-else-if="item.live_status==1" class="live-list-section-left-zl" src="/static/img/live/icon_list_tag_live_process.svg" alt="">
                                    <img v-else-if="item.live_status==2" class="live-list-section-left-zl" src="/static/img/live/icon_list_tag_live_history.svg" alt="">
                                </div>
                                <div class="live-list-section-right">
                                    <div class="live-list-section-right-title">{{item.title}}</div>
                                    <div class="course-list-section-right-detail" v-if="item.type==2">已开展{{item.current_count}}节 | 共{{item.total_count}}节</div>
                                    <div class="live-list-section-right-detail" v-else>{{item.start_at}}
                                        <span class="live-list-section-right-detail-join" v-if="item.live_status < 2">
                                        {{item.live_status === 0 ? item.isAppointment ? '已预约':'预约' : '加入'}}
                                    </span>
                                        <span v-else>{{item.view_count}}人观看</span>
                                    </div>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="clear"></div>
                        </div>

                        <div v-if="item.origin_type == 13" class="topic-list-box">
                            <div class="top">
                                <img class="logo" :src="item.logo" alt/>
                                <div class="top-name">{{ item.title }}</div>
                                <div class="more">
                                    更多
                                    <img src="/static/img/icon_more.svg" alt />
                                </div>
                            </div>
                            <van-image fit="cover" class="big-img" :src="item.cover_img"/>
                            <div class="topic-list-box-desc">{{item.desc}}</div>
                        </div>

                        <div v-if="item.origin_type == 14" class="meeting-list-section">
                            <div class="meeting-list-section-box">
                                <div class="meeting-list-section-box-first">
                                    <img class="meeting-list-section-main-img" :src="item.cover_img" alt="">
                                    <div class="meeting-list-section-left-zl">{{item.status_text}}</div>
                                    <div class="meeting-list-section-footer">
                                        <div class="meeting-list-section-footer-title">{{item.title}}</div>
                                        <div class="meeting-list-section-footer-detail">{{item.start_at}}~{{item.end_at}}</div>
                                    </div>
                                </div>
                                <div class="clear"></div>
                            </div>
                        </div>

                        <div class="clear"></div>
                    </div>
                </div>

                <div class="clear"></div>
                <div class="van-list__finished-text" style="margin-top: 15px" v-if="channel_page === channel_total_page">没有更多了</div>
                <div v-else class="finish-more" style="margin-top: 15px;margin-bottom: 70px" @click="fetch_more_channel()">查看更多</div>
            </div>

            <van-tabbar class="home-footer" :border="false" :fixed="true" :safe-area-inset-bottom="true" v-model="active" active-color="#D3172E">
                <van-tabbar-item @click="goHome()">
                    <span class="home-footer-span-else">首页</span>
                    <template #icon="props">
                        <div class="home-footer-icon-else">
                            <img src="/static/img/icon_tab_home_1.svg" alt="">
                        </div>
                    </template>
                </van-tabbar-item>
                <van-tabbar-item to="live-list">
                    <span class="home-footer-span">直播</span>
                    <template #icon="props">
                        <div class="home-footer-icon">
                            <img src="/static/two/tabbar_live.svg" alt="">
                        </div>
                    </template>
                </van-tabbar-item>
                <van-tabbar-item to="my">
                    <span class="home-footer-span-else">我的</span>
                    <template #icon="props">
                        <div class="home-footer-icon-else">
                            <img src="/static/img/icon_tab_me_2.svg" alt="">
                        </div>
                    </template>
                </van-tabbar-item>
            </van-tabbar>
        </div>
    </div>
</template>

<script>

import Interface from "@/util/interface"
import homeSkeleton from "@/skeleton/homeSkeleton"
import Overlay from "../live/list/overlay";

export default {
    name: 'home',
    components :{
        Overlay,
        'home-skeleton' : homeSkeleton
    },
    data() {
        return {
            value: "",
            banners:[],
            recommend:[],
            articles:[],
            active:0,
            loading :true,
            page:1,
            pageSize:10,
            total_page:1,
            swiperOptionBanner:{
                width:375,
                height:98,
                spaceBetween:30,
                autoplay:true,
                loop:true,
            },
            swiperOption:{
                width:192,
                height:249,
                spaceBetween:15,
            },
            swiperOption3:{
                width:70,
                height:70,
            },
            category_index:0,
            categories:[

            ],
            position_type1 : [],
            position_type2 : [],
            isTopic:0,
            channel_type:0,
            tableData:[],
            channel_page:1,
            channel:{},
            channel_total_page:0,
        }
    },
    methods: {
        fetch(scene) {
            if (scene === 'banner') {
                Interface.getData('get',Interface.home).then((res)=>{
                    this.banners = res.data.banners
                    this.recommend = res.data.recommend
                    this.position_type1 = res.data.position_type_1
                    this.position_type2 = res.data.position_type_2
                    this.fetch('tags')
                    setTimeout(()=>{
                        this.loading = false;
                    },100)
                    Interface.getShareInfo(this,"","","一站式垂直医生社区，学术会议、指南文献、医学资讯、实用工具。")
                })
            }else if (scene === 'article') {
                let params = {
                    page : this.page,
                    pageSize:10
                }
                Interface.getData('get', Interface.article.list,params).then((res) => {
                    this.articles = res.data.list
                    this.total_page = res.data.total_page
                })
            }else if (scene === 'tags') {
                let params = {
                    page : 1,
                    pageSize:999
                }
                Interface.getData('get', Interface.channel,params).then((res) => {
                    if(res.data.list){
                        this.categories.push({id:0,title:"推荐"})
                        this.categories.push(...res.data.list)
                        let search_channel = localStorage.getItem("search_channel")
                        if(this.$route.query.search_channel > 0){
                            this.category_index = parseInt(this.$route.query.search_channel)
                            this.changeCategory()
                        }else if (search_channel != null){
                            this.category_index = parseInt(search_channel)
                            this.changeCategory()
                        }
                    }else{
                        this.changeCategory()
                    }
                })
            }else if (scene === 'channel_item') {
                if(this.category_index == 0){
                    return
                }
                let params = {
                    page : this.channel_page,
                    pageSize:10,
                }
                Interface.getData('get', Interface.channel+"/"+this.channel.id,params).then((res) => {
                    if(res.data.list){
                        this.tableData.push(...res.data.list)
                        this.channel_total_page = res.data.total_page
                    }
                })
            }
        },
        fetch_more(){
            this.page += 1
            let params = {
                page : this.page,
                pageSize:10
            }
            Interface.getData('get', Interface.article.list,params).then((res) => {
                this.articles.push(...res.data.list)
            })
        },
        fetch_more_channel(){
            this.channel_page += 1
            let params = {
                page : this.channel_page,
                pageSize:10
            }
            Interface.getData('get', Interface.channel+"/"+this.channel.id,params).then((res) => {
                if(res.data.list){
                    this.tableData.push(...res.data.list)
                }
            })
        },
        go_detail(item){
            if (item.type != 2){
                this.$router.push({'name':'course-detail',params:{id:item.id}})
            }else{
                this.$router.push({'name':'course-column',params:{id:item.id}})
            }
        },
        go_live_detail(item) {
            if (item.type === 2) {
                this.$router.push({'name': 'live-column', params: {id: item.id}})
            } else if (item.live_status === 6) {
                this.$router.push({'name': 'live-detail-home', params: {id: item.id}})
            } else {
                if (item.live_status === 0) {
                    this.$router.push({'name': 'live-detail', params: {id: item.id}})
                } else {
                    this.$router.push({'name': 'live-detail-home', params: {id: item.id}})
                }
            }
        },
        goArticle(item){
            Interface.goArticle(this,item)
        },
        goMath(){
            location.href = "weixin://dl/business/?t=kDTK66Y4Mzt"
        },
        goTopic(item){
            Interface.footPrint(18,item.id,0,"点击首页金刚区按钮 "+item.title)


            location.href = item.link
        },
        to(name){
            this.$router.push({
                name : name,
            })
        },
        goHome(){
            this.category_index = 0
            this.changeCategory()
        },
        changeCategory(){
            this.tableData = []
            this.channel_page = 1
            localStorage.setItem("search_channel",this.category_index)
            this.$router.push({
                name : "home",
                query: {
                    search_channel : this.category_index
                }
            })
            this.channel = this.categories[this.category_index]
            Interface.getShareBaseInfo(this,this.channel.title,"","")
            this.fetch("channel_item")
            this.$forceUpdate()
        },
        getCategory(){
            this.$forceUpdate()
        },
        handleChannelItem(item){
            switch (item.origin_type){
                case 1:
                    Interface.goCourse(this,item,true)
                    break
                case 2:
                    Interface.goArticle(this,item,true)
                    break
                case 3:
                    Interface.goVideo(this,item,true)
                    break
                case 4:
                    if (item.type === 2) {
                        this.$router.push({'name': 'live-column', params: {id: item.content_id}})
                    } else if (item.live_status === 6) {
                        this.$router.push({'name': 'live-detail-home', params: {id: item.content_id}})
                    } else {
                        if (item.live_status === 0) {
                            this.$router.push({'name': 'live-detail', params: {id: item.content_id}})
                        } else {
                            this.$router.push({'name': 'live-detail-home', params: {id: item.content_id}})
                        }
                    }
                    break
                case 5:
                    this.$router.push({ 'name': 'topic-detail',params:{id:row.id} })
                    break
                case 6:
                    this.$router.push({ 'name': 'topic-detail',params:{id:row.id} })
                    break
                case 7:
                    this.$router.push({ 'name': 'topic-detail',params:{id:row.id} })
                    break
                case 8:
                    this.$router.push({ 'name': 'topic-detail',params:{id:row.id} })
                    break
                case 9:
                    this.$router.push({ 'name': 'topic-detail',params:{id:row.id} })
                    break
                case 10:
                    this.$router.push({ 'name': 'topic-detail',params:{id:row.id} })
                    break
                case 11:
                    this.$router.push({ 'name': 'topic-detail',params:{id:row.id} })
                    break
                case 12:
                    this.$router.push({ 'name': 'topic-detail',params:{id:row.id} })
                    break
                case 13:
                    this.$router.push({ 'name': 'topic-detail',params:{id:item.origin_id} })
                    break
                case 14:
                    // if (item.origin_id == 2){
                    //     location.href = "http://conference-h5.dr-gobroad.com/#/login?m="+item.uuid
                    // }else{
                        location.href = "http://conference-h5.dr-gobroad.com/#/live-list?m="+item.uuid
                    // }
                    break
            }
        },
        liveApply(item) {
            if (item.isAppointment == false) {
                // 判断是否认证 0 未认证   1已认证
                let is_complete = localStorage.getItem('user').is_complete
                if (!is_complete) {
                    Interface.getData('get', Interface.v4.apply + '/' + item.id).then(res => {
                        if (res.code == 0) {
                            this.childrenItem = null
                            this.childrenItem = item
                            this.$refs.overlayRef.applyShow = true
                            this.fetch('homepage')
                        }
                    })
                }
            } else {
                Interface.goLiveDetail(this, item)
            }
        },
    },
    created() {
        this.fetch('banner')
        this.fetch('article')
        sessionStorage.removeItem("search_data")
    },
}
</script>

<style lang="scss">
@import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue